<mat-form-field appearance="fill">
    <mat-select name="frequencySelect" [value]="selectedFrequency" [panelClass]="panelClass"
        (selectionChange)="onFrequencyChange($event)">
        <mat-option *ngFor="let option of frequencyOptions" [value]="option">
            {{ option }}
        </mat-option>
    </mat-select>
</mat-form-field>
